export default "__VITE_ASSET__CeLLGQ2q__"